export const USER_IDS = {
  mapsClient: 'maps-client' as 'maps-client'
};
